import { render, staticRenderFns } from "./OCOPResults.vue?vue&type=template&id=782f51be"
import script from "./OCOPResults.vue?vue&type=script&lang=js"
export * from "./OCOPResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports